module.exports = __webpack_public_path__ + "img/500-server-t-4.f0a851a4.png";